import { constantToDisplayName } from "../core/constantToDisplayName";
import { Box } from 'tombac';
import { StatusDot, StatusDotContainer } from "../core/components/StatusDot/ContractStatusDot";
import { useFormatUserDate } from "../core/useFormatUserDate";
import styled from 'styled-components';
import { Table, Tbody, Td, Th, Thead, Tr } from "../contracts/list/Table";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CopiesList = ({
  copies,
  colorMapping
}) => {
  const formatDate = useFormatUserDate({
    withTime: true
  });
  return /*#__PURE__*/_jsxs(TableAuto, {
    "data-sentry-element": "TableAuto",
    "data-sentry-component": "CopiesList",
    "data-sentry-source-file": "CopiesList.tsx",
    children: [/*#__PURE__*/_jsx(Thead, {
      "data-sentry-element": "Thead",
      "data-sentry-source-file": "CopiesList.tsx",
      "data-sentry-element": "Thead",
      children: /*#__PURE__*/_jsxs(Tr, {
        "data-sentry-element": "Tr",
        "data-sentry-source-file": "CopiesList.tsx",
        "data-sentry-element": "Tr",
        children: [/*#__PURE__*/_jsx(Th, {
          "data-sentry-element": "Th",
          "data-sentry-source-file": "CopiesList.tsx",
          "data-sentry-element": "Th",
          children: "Status"
        }), /*#__PURE__*/_jsx(Th, {
          "data-sentry-element": "Th",
          "data-sentry-source-file": "CopiesList.tsx",
          "data-sentry-element": "Th",
          children: "ID"
        }), /*#__PURE__*/_jsx(Th, {
          "data-sentry-element": "Th",
          "data-sentry-source-file": "CopiesList.tsx",
          "data-sentry-element": "Th",
          children: "Created at"
        }), /*#__PURE__*/_jsx(Th, {
          "data-sentry-element": "Th",
          "data-sentry-source-file": "CopiesList.tsx",
          "data-sentry-element": "Th",
          children: "Copied to"
        })]
      })
    }), /*#__PURE__*/_jsx(Tbody, {
      "data-sentry-element": "Tbody",
      "data-sentry-source-file": "CopiesList.tsx",
      "data-sentry-element": "Tbody",
      children: copies.map(copy => {
        const colorScheme = colorMapping[copy.status];
        return /*#__PURE__*/_jsxs(Tr, {
          children: [/*#__PURE__*/_jsxs(Td, {
            children: [/*#__PURE__*/_jsx(Box, {
              $mr: '1sp',
              $display: "inline-block",
              children: /*#__PURE__*/_jsx(StatusDotContainer, {
                colorScheme: colorScheme,
                children: /*#__PURE__*/_jsx(StatusDot, {
                  colorScheme: colorScheme
                })
              })
            }), constantToDisplayName(copy.status)]
          }), /*#__PURE__*/_jsx(Td, {
            children: copy.id
          }), /*#__PURE__*/_jsx(Td, {
            children: formatDate(new Date(copy.createdAt))
          }), /*#__PURE__*/_jsx(Td, {
            children: copy.destUser
          })]
        }, copy.id);
      })
    })]
  });
};
export default CopiesList;
const TableAuto = styled(Table).withConfig({
  displayName: "CopiesList__TableAuto"
})(["table-layout:auto;"]);